export class StopExecution extends Error {
  constructor(message = 'Execution cycle stopped') {
    super(message);
  }
}
